(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["TIS_Homepage-logolist"] && !Shopify.designMode) return;
  try {
    

   jQuery(window).resize(function(){
  if(jQuery(window).width() < 450) {
    jQuery("sht-carousel-itm").removeClass("homepage_logo");
  }else{
    jQuery("sht-carousel-itm").addClass("homepage_logo");
  }
 });

  } catch(e) { console.error(e); }
})();
})();
